<template>
  <div>
    <ots-main-title></ots-main-title>
    <div class="applyManageAddBox">
      <el-form
        :model="customForm"
        :rules="customRules"
        ref="customForm"
        label-width="100px"
        class="demo-ruleForm"
        :validate-on-rule-change="false"
      >
        <div>
          <h2>基础信息</h2>
          <!-- 系统配置项 -->
          <el-form-item label="姓名" prop="realName">
            <el-input
              v-model.trim="customForm.realName"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="证件类型" prop="cardType">
            <el-select
              :disabled="isEdit"
              v-model.trim="customForm.cardType"
              placeholder="请选择"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in cardTypeList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="证件号" prop="cardNo">
            <el-input
              :disabled="isEdit"
              v-model="customForm.cardNo"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="性别" prop="sex">
            <el-select v-model="customForm.sex" placeholder="请选择">
              <el-option label="女" :value="0"></el-option>
              <el-option label="男" :value="1"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="手机号" prop="phone" class="notPhone">
            <el-input
              v-model="customForm.phone"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="邮箱" prop="email" class="notPhone">
            <el-input
              v-model="customForm.email"
              placeholder="请输入"
            ></el-input>
          </el-form-item>

          <el-form-item label="基础照片" class="upload-img">
            <div class="avatarTip">
              <el-upload
                action=""
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :http-request="uploadImg"
                :disabled="photoState == 1"
              >
                <div class="photo" @click="isCanUpload">
                  <img
                    v-if="customForm.photo"
                    :src="customForm.photo"
                    class="avatar"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ" v-if="basicsMapImgRules.setShowText">
                  {{ basicsMapImgRules.setShowText }}
                </p>
                <p class="col_grayQ" v-else>
                  1.必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。
                </p>
                <p class="col_grayQ">
                  图片支持
                  <span style="color: #fe5958">{{
                    basicsMapImgRules.setValue2
                      ? basicsMapImgRules.setValue2
                      : "jpg"
                  }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958"
                    >{{
                      basicsMapImgRules.setValue
                        ? basicsMapImgRules.setValue
                        : "2345"
                    }}
                    kb</span
                  >
                </p>
                <!-- <el-button type="primary" style="margin-top: 20px;" round v-if="isEdit" @click="deletePicLog" >删除照片上传记录</el-button> -->
              </div>
            </div>
          </el-form-item>

          <!-- 自定义表单项 -->
          <el-form-item
            :label="item.displayName"
            v-for="item in studentsInfo"
            :key="item.id"
            :class="{
              'upload-img': item.type == 'imageUpload',
              address: item.type == 'textarea',
            }"
            :prop="item.name"
          >
            <!-- (1) 基础信息, 自定义 - 下拉选项 -->
            <el-select
              v-model="customForm[item.name]"
              :placeholder="item.placeholder ? item.placeholder : '请选择'"
              v-if="
                item.type == 'province' ||
                item.type == 'select' ||
                item.type == 'subject' ||
                item.type == 'politicalStatus' ||
                item.type == 'nation'
              "
              @change="$forceUpdate()"
              value-key="item"
            >
              <el-option
                :value="data.name"
                v-for="(data, i) in item.valueVo"
                :key="i"
                :label="data.name"
              ></el-option>
            </el-select>

            <!-- (2) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'date'"
              :placeholder="item.placeholder ? item.placeholder : '选择日期'"
              @input="$forceUpdate()"
            ></el-date-picker>

            <!-- (3) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD HH:mm:ss) -->
            <el-date-picker
              v-model="customForm[item.name]"
              v-if="item.type == 'datetime'"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="
                item.placeholder ? item.placeholder : '选择日期时间'
              "
              @input="$forceUpdate()"
            ></el-date-picker>

            <!-- (4) 基础信息, 自定义 - 图片上传 ( beforeAvatarUploadExt 自定义图片上传配置 ) -->
            <div class="avatarTip" v-if="item.type == 'imageUpload'">
              <el-upload
                action=""
                :data="{ '0': item.name }"
                :show-file-list="false"
                :before-upload="
                  (file) => {
                    return beforeAvatarUploadExt(
                      file,
                      item.fileBack,
                      item.filesize
                    );
                  }
                "
                :http-request="uploadImgExt"
              >
                <div class="photo">
                  <img
                    v-if="customForm[item.name]"
                    :src="customForm[item.name]"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ">{{ item.remarks }}</p>
                <p class="col_grayQ">
                  图片支持
                  <span style="color: #fe5958">{{ item.fileBack }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958"> {{ item.filesize }} kb</span>
                </p>
              </div>
            </div>

            <!-- (5) 基础信息, 自定义 - 单行文本格式 -->
            <el-input
              type="text"
              v-model.trim="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 0"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
            ></el-input>

            <!-- (6) 基础信息, 自定义 - 单行文本格式 - 非数字 -->
            <el-input
              type="text"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              v-model="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 1"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
              auto-complete="off"
            ></el-input>

            <!-- (7) 基础信息, 自定义 - 多行文本格式 -->
            <el-input
              type="textarea"
              v-model="customForm[item.name]"
              v-if="item.type == 'textarea'"
              @change="isUseRule($event, item.name)"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
            ></el-input>

            <!-- (8) 基础信息, 自定义 - 生日日期格式 ( 根据身份证号码自动配置 ) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'birthday'"
              :placeholder="item.placeholder ? item.placeholder : '选择生日'"
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (9) 基础信息, 自定义 - 省市级联数据 ( 读取配置 js 文件获取 ) -->
            <el-cascader
              size="large"
              v-model="customForm[item.name]"
              :options="item.valueVo"
              :props="{ value: 'name', label: 'name', children: 'cityList' }"
              v-if="item.type == 'provinceCity'"
              @change="changeCity($event, item.name)"
            >
            </el-cascader>
          </el-form-item>
        </div>

        <!-- ----------- 院校信息 ----------- -->
        <div>
          <h2>院校信息</h2>
          <!-- 院校下拉列表, 院校用户禁用 -->
          <el-form-item label="就读院校" prop="schoolId">
            <el-select
              v-model="customForm.schoolId"
              placeholder="请选择"
              :disabled="unSchool"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in schoolList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 教学点下拉列表, 教学点用户禁用 -->
          <el-form-item :label="isSetStateName" prop="stationId">
            <el-select
              v-model="customForm.stationId"
              placeholder="请选择"
              :disabled="unStation"
            >
              <el-option
                :label="item.name"
                :value="item.id"
                v-for="item in stationIdList"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- 院校信息自定义部分 -->
          <el-form-item
            :label="item.displayName"
            v-for="item in schoolInfo"
            :key="item.id"
            :class="{
              'upload-img': item.type == 'imageUpload',
              address: item.type == 'textarea',
            }"
            :prop="item.name"
          >
            <!-- (1) 基础信息, 自定义 - 下拉选项 -->
            <el-select
              v-model="customForm[item.name]"
              :placeholder="item.placeholder ? item.placeholder : '请选择'"
              v-if="
                item.type == 'province' ||
                item.type == 'select' ||
                item.type == 'subject' ||
                item.type == 'politicalStatus' ||
                item.type == 'nation' ||
                item.type == 'level'
              "
              @change="
                item.type == 'level' && LscPlugs
                  ? isLevelAndSubject(item.type, item.name, $event)
                  : $forceUpdate()
              "
            >
              <el-option
                :value="data.name"
                v-for="(data, i) in item.valueVo"
                :key="i"
                :label="data.name"
              ></el-option>
            </el-select>

            <!-- (2) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'date'"
              :placeholder="item.placeholder ? item.placeholder : '选择日期'"
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (3) 基础信息, 自定义 - 时间格式 ( YYYY-MM-DD HH:mm:ss) -->
            <el-date-picker
              v-model="customForm[item.name]"
              v-if="item.type == 'datetime'"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="
                item.placeholder ? item.placeholder : '选择日期时间'
              "
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (4) 基础信息, 自定义 - 图片上传 ( beforeAvatarUploadExt 自定义图片上传配置 ) -->
            <div class="avatarTip" v-if="item.type == 'imageUpload'">
              <el-upload
                action=""
                :data="{ '0': item.name }"
                :show-file-list="false"
                :before-upload="
                  (file) => {
                    return beforeAvatarUploadExt(
                      file,
                      item.fileBack,
                      item.filesize
                    );
                  }
                "
                :http-request="uploadImgExt"
              >
                <div class="photo">
                  <img
                    v-if="customForm[item.name]"
                    :src="customForm[item.name]"
                  />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </div>
              </el-upload>
              <div class="upload-tips">
                <p class="col_grayQ">{{ item.remarks }}</p>
                <p class="col_grayQ">
                  图片支持
                  <span style="color: #fe5958">{{ item.fileBack }}</span>
                  格式，文件最大不超过
                  <span style="color: #fe5958"> {{ item.filesize }} kb</span>
                </p>
              </div>
            </div>

            <!-- (5) 基础信息, 自定义 - 单行文本格式 -->
            <el-input
              type="text"
              v-model.trim="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 0"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
            ></el-input>

            <!-- (6) 基础信息, 自定义 - 单行文本格式 - 非数字 -->
            <el-input
              type="text"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              v-model="customForm[item.name]"
              v-if="item.type == 'text' && item.dataType == 1"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
              @change="isUseRule($event, item.name)"
              auto-complete="off"
            ></el-input>

            <!-- (7) 基础信息, 自定义 - 多行文本格式 -->
            <el-input
              type="textarea"
              v-model="customForm[item.name]"
              v-if="item.type == 'textarea'"
              @change="isUseRule($event, item.name)"
              :placeholder="item.placeholder ? item.placeholder : '请输入'"
            ></el-input>

            <!-- (8) 基础信息, 自定义 - 生日日期格式 ( 根据身份证号码自动配置 ) -->
            <el-date-picker
              v-model="customForm[item.name]"
              type="date"
              value-format="yyyy-MM-dd"
              v-if="item.type == 'birthday'"
              :placeholder="item.placeholder ? item.placeholder : '选择日期'"
              @input="$forceUpdate()"
            >
            </el-date-picker>

            <!-- (9) 基础信息, 自定义 - 省市级联数据 ( 读取配置 js 文件获取 ) -->
            <el-cascader
              size="large"
              v-model="customForm[item.name]"
              :options="item.valueVo"
              :props="{ value: 'name', label: 'name', children: 'cityList' }"
              v-if="item.type == 'provinceCity'"
              @change="changeCity($event, item.name)"
            >
            </el-cascader>
          </el-form-item>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { getQueryAllSchool } from "@/http/modules/school";
import { getQueryAllStation } from "@/http/modules/station";
import { uploadExtSet } from "@/http/modules/custom";
import systemApi from '@/http/modules/system';
import {
  addUser,
  SelectUser,
  Update,
} from "@/http/modules/applySet/studentManage";
import {
  selectPlugs,
  getLevelListByRelationFN,
  getSubjectListByLevelFN,
} from "@/http/modules/baseSet/majorCourse";
export const checkPhone = (rule, value, callback) => {
  if (!value) {
    callback();
  } else {
    let phoneReg = /^1[3456789]\d{9}$/;
    if (phoneReg.test(value)) {
      callback();
    } else {
      callback(new Error("手机号格式错误"));
    }
  }
};
export default {
  name: "applyAdd",
  data() {
    return {
      courseSession: [],
      savePhoto: "",
      customForm: {
        stationId: "",
        schoolId: "",
      },
      customRulesStorage: {},
      customRules: {
        realName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        cardType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        cardNo: [{ required: true, message: "请输入证件号", trigger: "blur" }],
        sex: [{ required: true, message: "请输入性别", trigger: "blur" }],
        schoolId: [{ required: true, message: "请选择学校", trigger: "blur" }],
        stationId: [
          { required: true, message: "请选择函数站", trigger: "blur" },
        ],
        // photo: [{ required: true, message: "请上传照片", trigger: "change" }],
      },
      query: {},
      planId: "",
      schoolList: [],
      stationIdList: [],
      courseList: [],
      cardTypeList: [
        { id: 1, name: "身份证" },
        { id: 2, name: "护照" },
        { id: 3, name: "士官证" },
        { id: 4, name: "港澳台身份证" },
      ],
      level: [],
      subject: [],
      planInfo: {},
      roleType: "",
      unSchool: false,
      unStation: false,
      studentsInfo: [],
      schoolInfo: [],
      birthday: "",
      provinceCity: [],
      changePhoto: false,
      isSetStateName: "",
      basicsMapImgRules: "",
      subjectName: "",
      levelName: "",
      LscPlugs: "",
      applyState: 0,
      photoState: "",
      stationIdName: "",
      schoolListName: "",
      isMastPhone: false,
      isMastEmail: false,
    };
  },
  computed: {
    isEdit() {
      return this.$route.query.stuId ? true : false;
    },
  },
  watch: {
    "customForm.cardNo": "autoSetBitrhday",
    isMastPhone(val) {
      if(val){
        this.$set(this.customRules, 'phone', [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: checkPhone, trigger: "blur" },
        ])
      }else{
        this.$set(this.customRules, 'phone', []);
      }
    },
    isMastEmail(val) {
      if(val){
        this.$set(this.customRules, 'email', [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { message: "邮箱格式错误", trigger: "blur", type: "email" },
        ])
      }else{
        this.$set(this.customRules, 'email', []);
      }
    },
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);
    this.isSetState();
  },
  created() {
    this.stationIdName = this.$route.query.stationName;
    this.csoolIdName = this.$route.query.SchoolName;
    this.initDate();
    this.getPhoneAndEmailConfig();
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),

    isCanUpload() {
      if (this.photoState == 1) {
        this.$alert(
          "该学生照片已经过系统审核并通过，无法重新上传该学生照片",
          "修改提示",
          {
            confirmButtonText: "确定",
            type: "warning",
          }
        );
      } else {
        return;
      }
    },

    /***************************************
     * @this 设置初始数据
     ***************************************/
    initDate() {
      /* ** 自定义字段配置 ** */
      this.mixin_setUserExtInfo()
        .then((res) => {
          res.data.map((e) => {
            if (e.title == 1) {
              this.studentsInfo.push(e);
            } else if (e.title == 2) {
              this.schoolInfo.push(e);
            }
            if (e.type == "birthday") {
              this.birthday = e.name;
            } else if (e.type == "level") {
              this.levelName = e.name;
            } else if (e.type == "subject") {
              this.subjectName = e.name;
            }
          });
          this.customForm = Object.assign({}, this.customForm, res.customForm);
          this.customRules = Object.assign(this.customRules, res.customRules);
          this.customRulesStorage = JSON.parse(JSON.stringify(Object.assign(this.customRules, res.customRules)));

          /* ** 配置教学点下拉数据 ** */
          getQueryAllStation({ state: 1 }).then((res) => {
            if (this.unStation) {
              let stationnameList = res.data;
              let stationList = stationnameList.filter(
                (itme) => itme.name === this.stationIdName
              );
              this.stationIdList = stationList;
              this.customForm.stationId = stationList[0].id;
            } else {
              this.stationIdList = res.data;
            }
          });
          /* ** 配置院校下拉数据 ** */
          getQueryAllSchool({ state: 1 }).then((res) => {
            if (this.unSchool) {
              let unSchoolList = res.data;
              let schoolList = unSchoolList.filter(
                (itme) => itme.name === this.csoolIdName
              );
              this.schoolList = schoolList;
              this.customForm.schoolId = this.schoolList[0].id;
            } else {
              this.schoolList = res.data;
            }
          });

          this.setEditDate();
          this.$forceUpdate();
          return selectPlugs({ levelType: "level", subjectType: "subject" });
        })
        .then((res) => {
          if (res.data == "true") {
            this.LscPlugs = true;
            this.resetLscFn();
          } else {
            this.LscPlugs = false;
            return false;
          }
        });
      /* ** 用户权限判断: 院校/教学点 ** */
      this.mixin_getCommonInfo().then((res) => {
        this.roleType = res.roleType;
        if (res.roleType == 2) {
          this.unSchool = true;
          this.unStation = false;
        } else if (res.roleType == 3) {
          this.unStation = true;
          this.unSchool = false;
        }
      });
    },

    resetLscFn() {
      this.schoolInfo.map((e) => {
        if (e.name == this.levelName) {
          getLevelListByRelationFN().then((res) => {
            e.valueVo = res.data;
            this.level = res.data;
          });
        } else if (e.name == this.subjectName) {
          getSubjectListByLevelFN().then((res) => {
            if (res.code == 1) {
              e.valueVo = res.data;
            }
          });
        }
      });
    },

    isLevelAndSubject(type, name, event) {
      let levelId;
      this.level.map((e) => {
        if (event == e.name) {
          levelId = e.id;
        }
      });
      this.customForm[this.subjectName] = "";
      this.schoolInfo.map((e) => {
        if (e.name == this.subjectName) {
          getSubjectListByLevelFN({ levelId }).then((res) => {
            if (res.code == 1) {
              e.valueVo = res.data;
            }
          });
        }
      });
    },

    /*********************************
     * @isUseRule 是否使用校验规则
     *********************************/
    isUseRule(val1, val2) {
      const { required } = this.customRulesStorage[val2][0]
      if (!required) this.customRules[val2][0].required = val1 ? true: false
    },

    /***********************************
     * @isSetState 系统是否设置了教学点标题
     ***********************************/
    isSetState() {
      this.$api.system.getConfigData().then((res) => {
        let stationName = "";
        res.data.configList.map((e) => {
          if (e.setName == "stationName") {
            stationName = e.setValue2;
          } else if (e.setName == "stuImgCondition") {
            e.setShowText = e.setShowText
              ? e.setShowText
              : "1. 必须是报考人本人真实免冠照片，不许带眼镜，照片应清晰可识别身份，过于模糊的照片无法上报成功。";
            e.setValue2 = e.setValue2 ? e.setValue2 : "jpeg";
            e.setValue = e.setValue ? e.setValue : "2345";
            this.basicsMapImgRules = e;
          }
        });
        this.isSetStateName = "教学点";
      });
    },

    /**************************
     * @changeCity 省市级联
     *************************/
    changeCity(e, item) {
      if (this.provinceCity.includes(item)) {
        return false;
      } else {
        this.provinceCity.push(item);
      }
    },

    /***************************************
     * @this 如果是编辑,设置默认数据
     ***************************************/
    setEditDate() {
      let stuId = this.$route.query.stuId;
      if (stuId) {
        document
          .querySelector(".el-breadcrumb")
          .querySelector(".currentBread")
          .querySelector(".el-breadcrumb__inner").innerText = "修改学生信息";
        SelectUser({ stuId }).then((res) => {
          res.data.extData.forEach((item) => {
            if (item.type == "provinceCity" && item.value) {
              this.customForm[item.name] = item.value.split(",");
              this.provinceCity.push(item.name);
            } else {
              this.customForm[item.name] = item.value;
            }
          });
          if (this.unSchool) {
            this.customForm = Object.assign({}, this.customForm, {
              id: res.data.id,
              realName: res.data.realName,
              cardType: res.data.cardType,
              cardNo: res.data.cardNo,
              sex: res.data.sex,
              phone: res.data.phone,
              email: res.data.email,
              photo: res.data.photo,
              schoolId: this.customForm.schoolId,
              stationId: res.data.stationId,
            });
          }
           if(this.unStation){
            this.customForm = Object.assign({}, this.customForm, {
              id: res.data.id,
              realName: res.data.realName,
              cardType: res.data.cardType,
              cardNo: res.data.cardNo,
              sex: res.data.sex,
              phone: res.data.phone,
              email: res.data.email,
              photo: res.data.photo,
              schoolId: res.data.schoolId,
              stationId: this.customForm.stationId,
            });
          }
          if(!this.unSchool && !this.unStation){
            this.customForm = Object.assign({}, this.customForm, {
              id: res.data.id,
              realName: res.data.realName,
              cardType: res.data.cardType,
              cardNo: res.data.cardNo,
              sex: res.data.sex,
              phone: res.data.phone,
              email: res.data.email,
              photo: res.data.photo,
              schoolId: res.data.schoolId,
              stationId: res.data.stationId,
            });
          }
          this.photoState = res.data.photoState;
          this.applyState = res.data.applyState;
          this.changePhoto = true;
        });
      }
    },
    /***************************************
     * @this 删除照片上传记录
     ***************************************/
    deletePicLog() {
      this.$api.applyManage
        .deleteDish({ cardNo: this.customForm.cardNo })
        .then((res) => {
          if (res.code) {
            this.$message.success("已删除照片上传记录");
          }
        });
    },

    /***************************************
     * @this 处理出生日期
     ***************************************/
    autoSetBitrhday(val) {
      let { cardType } = this.customForm;
      let birthday = "";
      if (cardType === 1) {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6);
        } else if (val.length == 18) {
          birthday = val.substr(6, 8);
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
        this.customForm[this.birthday] = birthday;
      }
    },

    /***************************************
     * @beforeAvatarUpload 图片上传
     ***************************************/
    beforeAvatarUpload(fileData) {
      let ImgRules = this.basicsMapImgRules.setValue2.split(",");
      if (ImgRules.includes("jpg") && !ImgRules.includes("jpeg")) {
        ImgRules.push("jpeg");
      } else if (ImgRules.includes("jpeg") && !ImgRules.includes("jpg")) {
        ImgRules.push("jpg");
      }
      let type = fileData.type.split("/")[1];
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < this.basicsMapImgRules.setValue;
      if (!isJPG) {
        this.$message.error(
          `上传头像图片只能是 ${this.basicsMapImgRules.setValue2} 格式!`
        );
      }
      if (!isLt30kb) {
        this.$message.error(
          `上传头像图片大小不能超过 ${this.basicsMapImgRules.setValue} kb!`
        );
      }
      return isJPG && isLt30kb;
    },

    /***************************************
     * @beforeAvatarUploadExt 自定义图片上传
     ***************************************/
    beforeAvatarUploadExt(fileData, fileType, fileSize) {
      let ImgRules = fileType.split(",");
      let key = "";
      for (let i = 0; i < ImgRules.length; i++) {
        if (ImgRules[i] == "jpg") {
          key = i;
        }
      }
      ImgRules[key] = "jpeg";
      let type = fileData.type.split("/")[1];
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < fileSize;
      if (!isJPG) {
        this.$message.error(`上传图片只能是 ${fileType} 格式!`);
      }
      if (!isLt30kb) {
        this.$message.error(`上传图片大小不能超过 ${fileSize} kb!`);
      }
      return isJPG && isLt30kb;
    },

    /***************************************
     * @this 学生照片(固定字段)
     ****************************************/
    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.customForm.photo = e.currentTarget.result;
        }
      };
      this.changePhoto = false;
    },

    /**************************************
     * @this 图片文件上传(自定义)--数据配置
     **************************************/
    uploadImgExt(data) {
      let attr = data.data[0];
      let fileData = data.file;
      let fileTypeLast = data.file.name.lastIndexOf(".");
      let fileType = "";
      if (fileTypeLast !== -1) {
        fileType = data.file.name.slice(fileTypeLast + 1).toLowerCase();
      } else {
        return false;
      }
      this.upLoadSstate(fileData, fileType, attr);
    },

    /**************************************
     * @this 图片文件上传(自定义)--图片上传
     **************************************/
    upLoadSstate(fileData, fileType, attr) {
      let formData = new FormData();
      formData.append("upfile", fileData);
      formData.append("fileType", fileType);
      uploadExtSet(formData).then((res) => {
        this.customForm[attr] = res.data;
      });
    },

    /***************************************
     * @this 保存/修改
     ***************************************/
    save() {
      this.saveEnd();
      // 准考证照片改为了取报名照片
      // this.$refs["customForm"].validate((valid) => {
      //   if (valid) {
      //     if (this.$route.query.stuId && this.applyState == 1) {
      //       this.$confirm(
      //         "学生已报名，信息修改后，准考证内容随着改变，请确认是否修改？",
      //         "导入结果",
      //         {
      //           confirmButtonText: "确定",
      //           cancelButtonText: "取消",
      //           type: "warning",
      //         }
      //       )
      //         .then(() => {
      //           this.saveEnd();
      //         })
      //         .catch(() => {
      //           return false;
      //         });
      //     } else {
      //       this.saveEnd();
      //     }
      //   }
      // });
    },
    saveEnd() {
      if(this.customForm.realName == ''){
        this.$message.error("请输入学生姓名");
        return;
      }
      if(this.customForm.cardType == ''){
        this.$message.error("请选择证件类型");
        return;
      }
      if(this.customForm.cardNo == ''){
        this.$message.error("请输入证件号");
        return;
      }
      if(this.customForm.sex == null || this.customForm.sex === '' ){
        this.$message.error("请选择性别");
        return;
      }
      if(this.isMastPhone){
        if(this.customForm.phone == '' || this.customForm.phone == null){
          this.$message.error("请输入手机号");
          return;
        }
      }
      if(this.customForm.phone){
        if(!/^1[3-9]\d{9}$/.test(this.customForm.phone)){
          this.$message.error("请输入正确的手机号");
          return;
        }
      }
      if(this.isMastEmail){
        if(this.customForm.email == '' || this.customForm.email == null){
          this.$message.error("请输入邮箱");
          return;
        }
      }
      if(this.customForm.email){
        if(!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.customForm.email)){
          this.$message.error("请输入正确的邮箱");
          return;
        }
      }
      if(this.customForm.schoolId == ''){
        this.$message.error("请选择院校");
        return;
      }
      if(this.customForm.stationId == ''){
        this.$message.error("请选择教学点");
        return;
      }
      let hasError = false;
      Object.keys(this.customForm).forEach((key1) => {
        if(hasError){return;}
        if(key1.startsWith('attr')){
          Object.keys(this.customRules).forEach((key2) => {
            if(hasError){return;}
            if(key2.startsWith('attr') && key1 == key2){
              if(this.customRules[key2][0].required){
                if(this.customForm[key1] == ''){
                  this.$message.error(this.customRules[key2][0].message);
                  hasError = true;
                }
              }
            }
          })
        }
      })
      if(hasError){return;}
      this.savePhoto = this.customForm.photo;
      if (!this.changePhoto) {
        this.customForm.photo = this.customForm.photo.split(",")[1];
      }
      if (this.$route.query.stuId) {
        delete this.customForm.extData;
      }
      delete this.customForm.placeId;
      delete this.customForm.courseId;
      for (let key in this.customForm) {
        if (this.provinceCity.includes(key)) {
          this.customForm[key] = this.customForm[key].toString();
        }
      }

      let saveState = this.customForm.id ? Update : addUser;
      let params = {
        ...this.customForm,
      };
      this.customForm.photo = this.savePhoto;
      // 3. 有id编辑，没有id添加
      saveState(params).then((res) => {
        if (res.code) {
          this.$message({
            message: this.customForm.id ? "修改成功" : "添加成功",
            type: "success",
          });
          this.$event.$emit("getData");
          this.$router.push({ name: "studentManageMent" });
        }
      });
      this.$forceUpdate();
    },

    /***************************************
     * @this 创建成功,设置用户默认密码
     ***************************************/
    dealPassword(cardNo) {
      let resetPassword = "";
      let hanzi = new RegExp("[\u4e00-\u9fa5]");
      if (hanzi.test(cardNo)) {
        resetPassword = "000000";
      } else if (cardNo.length >= 6) {
        resetPassword = cardNo.substring(cardNo.length - 6);
      } else {
        let zeroNum = 6 - cardNo.length;
        for (let i = 0; i < zeroNum; i++) {
          resetPassword = resetPassword + "0";
        }
        resetPassword = resetPassword + cardNo;
      }
      return resetPassword;
    },

    /***************************************
     * @this 添加成功--返回
     ***************************************/
    goBack() {
      this.$router.go(-1);
    },
    async getPhoneAndEmailConfig() {
      let {code,data} = await systemApi.getPhoneAndEmailConfigFn();
      if (code==1 && data && data.length) {
        // 手机说明
        let phoneConfig = data.find(item => item.fieldName == 'phone')
        if (phoneConfig) {
          this.isMastPhone = phoneConfig.required == 0 ? false : true;
        }
        // 邮箱说明
        let emailConfig = data.find(item => item.fieldName == 'email')
        if (emailConfig) {
          this.isMastEmail = emailConfig.required == 0 ? false : true;
        }
      }
    }
  },
};
</script>

<style lang="less" scoped>
// /deep/ .el-form-item.notPhone.is-required {
//   .el-form-item__label::before {
//     content: "";
//     margin-right: 0px;
//     width: 0px;
//   }
// }

.applyManageAddBox {
  padding: 24px;
  background: #fff;
  border-radius: 8px;
  .time .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 240px;
  }
  h1 {
    color: #2d2f33;
    font-size: 20px;
    padding-bottom: 24px;
  }
  h2 {
    font-size: 16px;
    color: #2d2f33;
    padding: 32px 0;
    border-top: 1px solid #f1f2f5;
  }
  /deep/ .el-input__inner {
    width: 240px;
    height: 36px;
  }
  /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    .upLoadSstate {
      position: absolute;
      left: 30px;
      top: 100px;
    }
  }
  .avatar-uploader .el-upload:hover {
    border-color: #006aff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 116px;
    height: 152px;
    line-height: 152px;
    text-align: center;
  }
  .avatar {
    width: 116px;
    height: 152px;
  }
  .avatarTip {
    display: flex;
    padding-top: 8px;
    vertical-align: top;
    line-height: 1.8;
  }
  .dbi {
    display: inline-block;
  }
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 116px;
    height: 152px;
  }
  .avatar-uploader /deep/ .el-upload:hover {
    border-color: #006aff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
  }
  .avatar-uploader /deep/ .el-upload:hover .avatar-uploader-icon {
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 3;
  }
}
.address /deep/ .el-textarea__inner {
  width: 70%;
}
.upload-img {
  .photo {
    width: 116px;
    height: 152px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  /deep/ .el-form-item__content {
    display: flex;
  }
}
.upload-tips {
  padding-left: 10px;
}
/deep/ .el-radio-button__inner {
  margin-right: 16px;
  margin-bottom: 11px;
  color: #45494d !important;
  background: #f4f5f8 !important;
  font-size: 13px;
  border-radius: 4px !important;
  border: 1px solid #dadde6 !important;
  padding: 10px 20px;
}
/deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #ebf5ff !important;
  border: 1px solid #006aff !important;
  color: #006aff !important;
  box-shadow: none;
}
.examType {
  margin: 0 16px 11px 0;
  /deep/ .el-radio-button__inner {
    margin: 0 !important;
  }
}
/* ** 课程场次样式 (禁用) ** */
.examType.is-disabled {
  /deep/ .el-radio-button__inner {
    color: #c2c6cc !important ;
    background-color: #f1f2f5 !important ;
    border: 1px solid #dadde6 !important ;
  }
}
.examType.is-active {
  /deep/ .el-radio-button__inner {
    color: #006aff !important ;
    background-color: #ebf5ff !important ;
    border: 1px solid #006aff !important ;
  }
}
.examType.is-disabled.is-active {
  /deep/ .el-radio-button__inner {
    color: #006aff !important ;
    background-color: #f1f2f5 !important ;
    border: 1px solid #006aff !important ;
  }
}
/* 2021/11/26 IE 表单样式问题(盒模型大小同谷歌有异) */
/deep/ .el-input .el-input__inner {
  width: 240px;
  height: 36px;
  line-height: 18px;
}
img{
  width: 116px;
    height: 152px;
}
</style>
